import { render, staticRenderFns } from "./recursoProprio.vue?vue&type=template&id=3cadec9a&scoped=true"
import script from "./recursoProprio.vue?vue&type=script&lang=js"
export * from "./recursoProprio.vue?vue&type=script&lang=js"
import style0 from "./recursoProprio.vue?vue&type=style&index=0&id=3cadec9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cadec9a",
  null
  
)

export default component.exports